import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeNewsCard.cardTitle',
    defaultMessage: 'News',
  },
  buttonLabelNewsCard: {
    id: 'homeNewsCard.buttonLabelNewsCard',
    defaultMessage: 'Visualizza',
  },
  descriptionNewsCardNoNews: {
    id: 'homeNewsCard.descriptionNewsCardNoNews',
    defaultMessage: 'Nessuna news presente',
  },
});
